import { render } from "./DistributorOrdersTable.vue?vue&type=template&id=c46a644e&scoped=true"
import script from "./DistributorOrdersTable.vue?vue&type=script&lang=js"
export * from "./DistributorOrdersTable.vue?vue&type=script&lang=js"

import "./DistributorOrdersTable.vue?vue&type=style&index=0&id=c46a644e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46a644e"]])

export default __exports__